export const CLEAR_STATE = 'CLEAR_STATE';
export const UPDATE_MOBILE = 'UPDATE_MOBILE';
export const UPDATE_SCREEN = 'UPDATE_SCREEN';
export const UPDATE_VIEW = 'UPDATE_VIEW';
export const UPDATE_MENU = 'UPDATE_MENU';
export const UPDATE_PROJECTS_LIST = 'UPDATE_PROJECTS_LIST';
export const UPDATE_COMMAND_LIST = 'UPDATE_COMMAND_LIST';
export const UPDATE_WINDOW = 'UPDATE_WINDOW';
export const UPDATE_VISIBILITY = 'UPDATE_VISIBILITY';
export const UPDATE_TAB = 'UPDATE_TAB';
export const UPDATE_SCROLLTOP = 'UPDATE_SCROLLTOP';
export const ADD_TASKBAR_WINDOW = 'ADD_TASKBAR_WINDOW';
export const REMOVE_TASKBAR_WINDOW = 'REMOVE_TASKBAR_WINDOW'; 